import { Stack } from "@mui/material";

import { getSafeAreaPaddings } from "../../../ui-theme";

export interface PageFooterProps {
  children?: React.ReactNode;
}

export function PageFooter(props: PageFooterProps) {
  const { children } = props;

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      gap={4}
      sx={(theme) => ({
        px: 5,
        paddingTop: 5,
        ...getSafeAreaPaddings({
          bottom: true,
          fallbackBottom: theme.spacing(5),
        }),
      })}
    >
      {children}
    </Stack>
  );
}
